import { FeederContractStatusEnum } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { StatusDefinition } from '../status.model';

/** Einspeisevertrag (`FeederContract.state`). */
export const FEEDER_CONTRACT_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  { value: FeederContractStatusEnum.ToBeCreated, defaultLabel: 'In Erstellung', defaultColor: '#f0b429' },
  { value: FeederContractStatusEnum.Created, defaultLabel: 'Offen', defaultColor: '#71dde3' },
  {
    value: FeederContractStatusEnum.TechnicallyReviewed,
    defaultLabel: 'Fachlich geprüft',
    defaultColor: '#C3E88D'
  },
  {
    value: FeederContractStatusEnum.ConfirmationRequestedByMail,
    defaultLabel: 'Vertragsangebot per E-Mail versandt',
    defaultColor: '#e7ce06'
  },
  {
    value: FeederContractStatusEnum.ClosedWithoutFeedback,
    defaultLabel: 'Ohne Kundenfeedback geschlossen',
    defaultColor: '#e7ce06'
  },
  { value: FeederContractStatusEnum.FeedbackNeeded, defaultLabel: 'Rückfrage', defaultColor: '#f0b429' },
  { value: FeederContractStatusEnum.Accepted, defaultLabel: 'Akzeptiert', defaultColor: '#e7ce06' },
  { value: FeederContractStatusEnum.Confirmed, defaultLabel: 'Bestätigt', defaultColor: '#71dde3' },
  { value: FeederContractStatusEnum.Cancelled, defaultLabel: 'Storniert', defaultColor: '#e99aa6' },
  { value: FeederContractStatusEnum.Completed, defaultLabel: 'Abgeschlossen', defaultColor: '#e99aa6' }
];
